import './App.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./CSS/reset.css";

import Header from './components/header';
import Footer from './components/footer';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './pages/about';
import Home from './pages/home';
import Publications from './pages/research/publications';
import Roverview from './pages/research/overview';
import Sustainablility from './pages/research/sustainability';
import Traditional from './pages/research/traditional';
import Coverview from './pages/colearning/overview';
import RDTAlternative from './pages/colearning/rdtalternative';
import TraditionalKnowledge from './pages/colearning/traditionalknowledge';
import Entrepreneurship from './pages/colearning/entrepreneurship';
import JoyOverview from './pages/joylab/overview';
import JoyBlog from './pages/joylab/blog';
import Contact from './pages/contact';
import Events from './pages/events';
import { SpeedInsights } from "@vercel/speed-insights/react";
import DesignThinking from './pages/colearning/designthinking';
import NotFound from './pages/notfound';
import SparcSymp from './pages/events/sparcsymp';
import SparcCourse from './pages/events/sparccourse';
import ArtisanalProduction from './pages/colearning/artisanalproduction';
import EitecEnt from './pages/events/eitecEnt';
import EitecHealth from './pages/events/eitecHealth';
import PossibilitiesDialogue from './pages/events/possibilitesDialogue';
import Cipra from './pages/events/cipra';
import LifeSkills from './pages/colearning/lifeskills';
import EduCarnival from './pages/events/educarnival';

function App() {
  return (
    <>
    <SpeedInsights/>
    
    <Router basename="/~chariarv/">
    <Header/>
      <Routes>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="events" element={<Events />} />

        <Route path="research/publications" element={<Publications />} />
        <Route path="research/overview" element={<Roverview />} />
        <Route path="research/sustainability" element={<Sustainablility />} />
        <Route path="research/traditional" element={<Traditional />} />

        <Route path="colearning/traditionalknowledge" element={<TraditionalKnowledge />} />
        <Route path="colearning/artisanalproduction" element={<ArtisanalProduction />} />
        <Route path="colearning/overview" element={<Coverview />} />
        <Route path="colearning/rdtalternative" element={<RDTAlternative />} />
        <Route path="colearning/entrepreneurship" element={<Entrepreneurship />} />
        <Route path="colearning/lifeskills" element={<LifeSkills />} />
        <Route path="colearning/dti" element={<DesignThinking />} />

        <Route path="joylab/overview" element={<JoyOverview />} />
        <Route path="joylab/blog" element={<JoyBlog />} />

        <Route path="events/possibilitiesDialogue" element={<PossibilitiesDialogue />} />
    
        <Route path="events/sparcsyposium" element={<SparcSymp />} />
        <Route path="events/sparccourse" element={<SparcCourse />} />
        <Route path="events/eitecent" element={<EitecEnt />} />
        <Route path="events/eitechealth" element={<EitecHealth />} />
        <Route path="events/cipra" element={<Cipra />} />
        <Route path="events/educarnival25" element={<EduCarnival />} />
        

        <Route path="*" element={<NotFound />} />
      </Routes>

    <Footer/>
    </Router>
    </>
  );
}

export default App;
